import React from "react";
import "./report.css";

export default function BiasMapReport() {
  return (
    <div className="report-container">
      <h1>
        BiasMap: Full-Stack Framework for Analyzing Fact Extraction Biases
      </h1>

      <pre className="report-text">
        {`BiasMap is a full-stack analytics framework designed to quantify and visualize fact-extraction biases across large-scale news corpora. The system integrates interactive visual dashboards, NLP pipelines, and scalable APIs to support bias analysis at the level of entities, claims, and sources.

FRONTEND IMPLEMENTATION
• Built using Nuxt 3 (Vue 3 + TypeScript) for a reactive single-page application with SSR (server-side rendering) for SEO and fast hydration.
• Integrated D3.js and Plotly.js for interactive, real-time bias visualizations, including heatmaps, Sankey diagrams, chord networks, and entity-relation graphs.
• Designed modular Vue components for filtering, source comparison, and temporal trend analysis, enabling users to explore bias evolution across datasets.
• Implemented RESTful client integration with FastAPI endpoints for live data streaming and visual updates.
• Employed responsive layout and accessibility design to ensure usability across desktop and tablet interfaces.

BACKEND IMPLEMENTATION
• Developed a FastAPI backend providing scalable REST and WebSocket endpoints for bias computation and visualization updates.
• Implemented data ingestion and NLP processing pipelines with Pandas, NetworkX, and Groq API (Llama-3) to extract entities, claims, sentiment, and bias vectors from 338+ verified news sources.
• Built modular services for:
  - Entity Linking & Normalization: Mapping facts to knowledge graph nodes (CatchNet).
  - Bias Scoring Engine: Quantifying linguistic and factual skew using attention-based embeddings and contextual sentiment.
  - Aggregation Layer: Computing per-source and cross-cluster bias summaries with Pandas and NumPy for real-time rendering.
• Utilized PostgreSQL for persistent storage of processed entities and bias metrics, optimized with indexed queries and batch commits.
• Enabled parallel processing via asynchronous FastAPI workers and cached frequently requested data through in-memory storage to improve response times.

DATA PIPELINE & INFRASTRUCTURE
• Designed modular ETL flows to collect raw articles, clean metadata, and normalize entities before NLP analysis.
• Implemented task orchestration for concurrent processing and streaming of new articles into the visualization layer.
• Exposed unified analytics endpoints used by the Nuxt 3 frontend for real-time dashboard updates.

IMPACT & OUTCOMES
• Enabled researchers to identify systematic linguistic biases, sentiment asymmetries, and topic-source relationships at scale.
• Delivered a 30% improvement in data consistency and traceability for the CatchNet knowledge graph.
• Empowered analysts to visualize and compare political and factual bias trends interactively across hundreds of global media outlets.

FUTURE SCOPE
• Extend to multilingual datasets and cross-lingual bias detection.
• Integrate model explainability dashboards (SHAP/LIME) for transparency in bias scoring.
• Deploy via containerized microservices (Docker + Kubernetes) for large-scale research collaboration.

BiasMap provides a transparent, extensible framework for bias quantification and visualization—bridging NLP, data science, and interactive analytics in a cohesive full-stack ecosystem.`}
      </pre>
    </div>
  );
}
